import { render, staticRenderFns } from "./ImportBjiOrder.vue?vue&type=template&id=7d8ae48a&lang=pug"
import script from "./ImportBjiOrder.vue?vue&type=script&lang=js"
export * from "./ImportBjiOrder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports